import {
  APP_LOADING,
  CLEAR,
  ERROR,
  SUCCESS,
  POPUP_ERROR,
} from "../constants/types/alertType";

const initialState = {
  messages: [],
  appLoading: false,
  popupMessages: [],
};
export const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS:
      return {
        ...state,
        messages: state.messages.concat({
          variant: "success",
          message: action.payload,
          id: Math.random(),
        }),
      };

    case ERROR:
      return {
        ...state,
        messages: state.messages.concat({
          variant: "danger",
          message: action.payload,
          id: Math.random(),
        }),
      };
    case POPUP_ERROR:
      return {
        ...state,
        popupMessages: state.popupMessages.concat({
          variant: "danger",
          message: action.payload,
          id: Math.random(),
        }),
      };
    case CLEAR:
      return {
        ...state,
        messages: state.messages.filter((x) => x.id !== action.payload),
        popupMessages: state.popupMessages.filter(
          (x) => x.id !== action.payload
        ),
      };
    case APP_LOADING:
      return {
        ...state,
        appLoading: action.payload,
      };
    default:
      return state;
  }
};
